import { Color } from '../../Enum/Color';
import { getHexColorByResult, getLabelByColor } from '../../Helpers/Color';
import { PieChartData, PieChartDataDTOInterface } from '../../Interface/Hook/PieChart/PieChartDataDTOInterface';
import { Result } from '../../Interface/Response/Validator/Result';
import ResultContext from '../../Context/ResultContext';
import { Scopable } from '../../Interface/Scopable';
import { sortByColor } from '../../Helpers/Sort';

import { useContext } from 'react';

const reduceScopeToPieChartData = (acc: { [key: string]: number }, currValue: Scopable): { [key: string]: number } => {
    const result = currValue.resultaat || 'N/A';
    if (currValue.resultaat !== Color.Blue) {
        acc[result] = acc[result] || 0;
        acc[result] += 1;
    }
    return acc;
};

const responseDataToPieChartData = (rules: Scopable[]): PieChartData[] => {
    const data = rules.reduce(reduceScopeToPieChartData, {});

    const pieChartData: PieChartData[] = [];
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            pieChartData.push({
                title: getLabelByColor(key as Color),
                value: data[key],
                color: getHexColorByResult(key as Color),
            });
        }
    }

    pieChartData.sort(sortByColor);

    return pieChartData;
};

const useGetPieChartData = (): PieChartDataDTOInterface | null => {
    const result = useContext<Result | null>(ResultContext);

    if (!result) {
        return null;
    }

    return {
        acceptanceFeatures: responseDataToPieChartData(result.beoordeling.beoordelingResponse.regel)
    };
};

export default useGetPieChartData;
